/**
 * Preset material property keys for MaterialComponent (ordered sections).
 * Values are read from / written to the mesh Three.js material via materialPropertyEditor.
 */

/** Already shown in the main Material panel controls — skip in preset sections. */
export const MATERIAL_PANEL_LEGACY_UI_KEYS = new Set([
  'color',
  'map',
  'normalMap',
  'metalnessMap',
  'roughnessMap',
  'emissiveMap',
  'alphaMap',
  'aoMap',
  'lightMap',
  'specularMap',
  'bumpMap',
  'displacementMap',
  'matcap',
  'gradientMap',
  'metalness',
  'roughness',
  'emissive',
  'emissiveIntensity',
  'opacity',
  'transparent',
  'side',
  'blending',
  'aoMapIntensity',
]);

export const MATERIAL_PROPERTY_LABELS = {
  opacity: 'Opacity',
  transparent: 'Transparent',
  alphaTest: 'Alpha Test',
  alphaHash: 'Alpha Hash',
  depthWrite: 'Depth Write',
  depthTest: 'Depth Test',
  visible: 'Visible',
  wireframe: 'Wireframe',
  wireframeLinewidth: 'Wireframe Width',
  flatShading: 'Flat Shading',
  fog: 'Fog',
  premultipliedAlpha: 'Premultiplied Alpha',
  dithering: 'Dithering',
  toneMapped: 'Tone Mapped',
  vertexColors: 'Vertex Colors',
  polygonOffset: 'Polygon Offset',
  polygonOffsetFactor: 'Polygon Offset Factor',
  polygonOffsetUnits: 'Polygon Offset Units',
  normalScale: 'Normal Scale',
  bumpScale: 'Bump Scale',
  displacementScale: 'Displacement Scale',
  displacementBias: 'Displacement Bias',
  lightMapIntensity: 'Light Map Intensity',
  envMapIntensity: 'Environment Intensity',
  shininess: 'Shininess',
  specular: 'Specular',
  reflectivity: 'Reflectivity',
  refractionRatio: 'Refraction Ratio',
  clearcoat: 'Clearcoat',
  clearcoatRoughness: 'Clearcoat Roughness',
  ior: 'IOR',
  sheen: 'Sheen',
  sheenRoughness: 'Sheen Roughness',
  sheenColor: 'Sheen Color',
  transmission: 'Transmission',
  thickness: 'Thickness',
  attenuationDistance: 'Attenuation Distance',
  attenuationColor: 'Attenuation Color',
  specularIntensity: 'Specular Intensity',
  specularColor: 'Specular Color',
  iridescence: 'Iridescence',
  iridescenceIOR: 'Iridescence IOR',
  anisotropy: 'Anisotropy',
  anisotropyRotation: 'Anisotropy Rotation',
  linewidth: 'Line Width',
};

export const MATERIAL_PANEL_SECTIONS = [
  // {
  //   id: 'transparency',
  //   title: 'Transparency & Depth',
  //   keys: [
  //     'alphaTest',
  //     'alphaHash',
  //     'depthWrite',
  //     'depthTest',
  //     'premultipliedAlpha',
  //   ],
  // },
  // {
  //   id: 'rendering',
  //   title: 'Rendering',
  //   keys: [
  //     'visible',
  //     'blending',
  //     'wireframe',
  //     'wireframeLinewidth',
  //     'flatShading',
  //     'fog',
  //     'dithering',
  //     'toneMapped',
  //     'vertexColors',
  //     'polygonOffset',
  //     'polygonOffsetFactor',
  //     'polygonOffsetUnits',
  //   ],
  // },
  {
    id: 'mapsScalars',
    title: 'Map Intensity & Scale',
    keys: [
      'normalScale',
      'bumpScale',
      'displacementScale',
      'displacementBias',
      'lightMapIntensity',
      'envMapIntensity',
    ],
  },
  {
    id: 'classic',
    title: 'Classic / Phong',
    keys: ['shininess', 'specular', 'reflectivity', 'refractionRatio'],
  },
  {
    id: 'physical',
    title: 'Physical (PBR+)',
    keys: [
      'clearcoat',
      'clearcoatRoughness',
      'ior',
      'sheen',
      'sheenRoughness',
      'sheenColor',
      'transmission',
      'thickness',
      'attenuationDistance',
      'attenuationColor',
      'specularIntensity',
      'specularColor',
      'iridescence',
      'iridescenceIOR',
      'anisotropy',
      'anisotropyRotation',
    ],
  },
  {
    id: 'line',
    title: 'Line',
    keys: ['linewidth'],
  },
];
